var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66677 6.66732H13.3501V3.33398H3.33344V13.334H6.66677V6.66732ZM6.66677 26.6673H3.33344V36.6673H13.3501V33.334H6.66677V26.6673ZM33.3334 33.334H26.6668V36.6673H36.6668V26.6673H33.3334V33.334ZM26.6668 6.66732H33.3334V13.334H36.6668V3.33398H26.6668V6.66732Z",
    fill: "#FFED00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33344 18.334H18.3334V8.33398H8.33344V18.334ZM11.6668 11.6673H15.0001V15.0007H11.6668V11.6673ZM8.33344 31.6673H18.3334V21.6673H8.33344V31.6673ZM11.6668 25.0007H15.0001V28.334H11.6668V25.0007ZM31.6668 8.33398H21.6668V18.334H31.6668V8.33398ZM28.3334 15.0007H25.0001V11.6673H28.3334V15.0007ZM21.6834 21.6673H25.0168V25.0007H21.6834V21.6673ZM25.0168 25.0007H28.3501V28.334H25.0168V25.0007ZM28.3501 28.334H31.6834V31.6673H28.3501V28.334ZM28.3501 21.6673H31.6834V25.0007H28.3501V21.6673Z",
    fill: "#FFED00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.9f4f211b75675823b1c39c7102fbe9b0.svg";
export { ForwardRef as ReactComponent };